import { compose } from './compose.no-deps'
import { not } from './boolean.no-deps'

/**
 * Create an iterator for arrays with values zipped together
 *
 *     for (const [a, b] of zipIterator([['A1', 'A2'], ['B1', 'B2']])) {
 *         console.log(a, b)
 *     }
 *
 *     // A1, B1
 *     // A2, B2
 */
export function* zipIterator<T>(arrays: T[][]): Generator<T[], void, void> {
    const lengths = arrays.map((a) => a.length)
    const maxLength = Math.max(...lengths)

    for (let i = 0; i < maxLength; i++) {
        yield arrays.map((a) => a[i])
    }
}

/**
 * Runs a predicate over a zipped iterator and returns true only if predicate is
 * true for all zipped values
 */
export function zipEvery<T>(arrays: T[][], fn: (zippedArray: T[]) => boolean) {
    for (const zippedArray of zipIterator(arrays)) {
        if (!fn(zippedArray)) return false
    }

    return true
}

/**
 * Runs a predicate over a zipped iterator and returns true if predicate is
 * true for at least some of the zipped values
 */
export function zipSome<T>(arrays: T[][], fn: (zippedArray: T[]) => boolean) {
    return !zipEvery(arrays, compose(fn, not))
}
